import React from 'react';
import { Section } from '../components/Section';
import { StartHere } from '../components/StartHere';
import { Atomizer } from '../components/home/Atomizer';
import { WhereWeSit } from '../components/home/WhereWeSit';
import { asset } from '../data/redesignAssets';
import { DEMO_URL } from '../data/links';
import { BRAND_ROWS, CHANGES, OWNERSHIP, TRUST, WHAT_IT_DOES, WHO_FOR } from '../data/home';
export function Home() {
  return <>
      <Section n="01" label="Instruction governance" noTop contentClassName="hero-c" data-id="element-436" data-mp="1zk1z5pf6j8dw">
        <img className="swirl" src={asset('hero-swirl-home.svg')} alt="" width={432} height={446} style={{
        right: -129,
        top: 87
      }} data-id="element-437" data-mp="24haihtc2digq" />
        <h1 className="h1" style={{
        maxWidth: 980
      }} data-id="element-438" data-mp="2dhqjmw5c4dif">
          Your rules, your policies, your
          <br className="d" data-id="element-439" data-mp="3kvadcpw1yhx4" /> know-how. Turned into instructions
          <br className="d" data-id="element-440" data-mp="3kv0nd2b0carf" /> your AI has to follow.
        </h1>
        <p className="lede" data-id="element-441" data-mp="3ow421lhbk0r2">
          <span className="nowrap-d" data-id="element-442" data-mp="3ovaskcqz6x58">We take what your company already knows, your policies, your</span>
          <br className="d" data-id="element-443" data-mp="30w04u1s2zm4k" /> business rules, the judgment calls your best people make every day, and put it to work inside the platforms you
          already use. No rebuilding your workflow. Fewer mistakes, and better business outcomes.
        </p>
        <div className="btns" data-id="element-444" data-mp="2mxjp5lc8qlaa">
          <a className="btn btn-s" href={DEMO_URL} target="_blank" rel="noopener" data-id="element-445" data-mp="2mw8kljaz19i4">
            Book a demo
          </a>
          <a className="btn btn-o" href="#atomizer" data-id="element-446" data-mp="2hz8h9g5iakup">
            See it on a real document <span className="mono" data-id="element-447" data-mp="2d5mau5pxrd7c">↓</span>
          </a>
        </div>
      </Section>

      <section className="bleed sec-dk does" data-id="element-448" data-mp="2895mpbiqkyu9">
        <div className="sec" style={{
        borderTop: 0
      }} data-id="element-449" data-mp="285ridxqiifk6">
          <div className="sec-m" data-id="element-450" data-mp="23ac81frpr1si">
            <div className="sec-l" data-id="element-451" data-mp="236y7md2m12np">What it does</div>
          </div>
          <div className="does-g" data-id="element-452" data-mp="1z64jbil99lua">
            {WHAT_IT_DOES.map(t => <div className="does-i" key={t} data-id="element-453" data-mp="1u8308xntxmit">
                <div className="t" data-id="element-454" data-mp="1uafpzwztx16f">{t}</div>
              </div>)}
          </div>
        </div>
      </section>

      <WhereWeSit data-id="element-455" data-mp="1omc8np75010a" />

      <Section n="03" label="Instruction data" id="atomizer" data-id="element-456" data-mp="1omu26e2f014i">
        <div className="hgroup" data-id="element-457" data-mp="1ojzg6i3r688z">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-458" data-mp="1an2oyfjq2ork">
            The rules already exist.
            <br data-id="element-459" data-mp="1fl4973svwu4m" />
            They’re just not instruction data.
          </h2>
          <p className="lede" data-id="element-460" data-mp="23b8d7c9zivw5">
            Your industry’s regulations, your policies, your best reviewer’s corrections, and the institutional knowledge nobody wrote
            down. Synthia turns all of it into instruction data: owned, versioned, portable, and yours.
          </p>
        </div>

        <Atomizer data-id="element-461" data-mp="1yki8805h0v1z" />

        <div className="cols own" style={{
        borderTop: '1px solid var(--line)',
        paddingTop: 24
      }} data-id="element-462" data-mp="1yjyocdw9fwlb">
          {OWNERSHIP.map(c => <div className="col" key={c.t} data-id="element-463" data-mp="2m9ayph3bqap7">
              <div className="col-t" data-id="element-464" data-mp="2r0syi1tm258l">{c.t}</div>
              <div className="col-b" data-id="element-465" data-mp="2r1kuvev186zx">{c.b}</div>
            </div>)}
        </div>
      </Section>

      <Section n="04" label="Attention loss" className="gridpaper bleed loss" data-id="element-466" data-mp="fk97pemcsnkh">
        <p className="big" data-id="element-467" data-mp="alo6pcza1zuz">At high instruction density, the best frontier model missed nearly one in three instructions.</p>
        <p className="sub" data-id="element-468" data-mp="odmb5ai1n7kt">It won’t tell you which. A wrong answer reads exactly like a right one.</p>
        <p className="cite" data-id="element-469" data-mp="kd29puqfthsv">
          <a href="https://arxiv.org/abs/2507.11538" target="_blank" rel="noopener" data-id="element-470" data-mp="3ssca8yeoieyj">
            IFScale, “How Many Instructions Can LLMs Follow at Once?”
          </a>{' '}
          · 68% adherence at high density
        </p>
      </Section>

      <Section n="05" label="What changes" className="changes" data-id="element-471" data-mp="5opc6tbpbqw9">
        <h2 className="h2" data-id="element-472" data-mp="ot8ywatw3hr">Right the first time, with receipts.</h2>
        <div className="cols" data-id="element-473" data-mp="n8grdbzkwn2">
          {CHANGES.map(c => <div className="col" key={c.t} data-id="element-474" data-mp="1h1rwnzgx90lp">
              <div className="t" data-id="element-475" data-mp="1h4mdzi4n25aw">{c.t}</div>
              <div className="b" data-id="element-476" data-mp="1c4hv5lg9cyhi">{c.b}</div>
            </div>)}
        </div>
      </Section>

      <Section n="06" label="Who it’s for" className="who" data-id="element-477" data-mp="27ey8ptlsjtx0">
        <div className="hgroup" data-id="element-478" data-mp="2cczrsej7vt8h">
          <h2 className="h2" style={{
          maxWidth: 900
        }} data-id="element-479" data-mp="2cc6j380p6tnp">
            Regulated work. Real consequences.
          </h2>
          <p className="lede" data-id="element-480" data-mp="2hb9pavsez5x9">
            Ask an AI the capital of France and there’s nothing to govern. The moment it drafts the denial, answers the regulator, or
            releases the payment, its output stops describing your business and starts <strong data-id="element-481" data-mp="2qawmt6i0vrl1">committing</strong> it.
          </p>
        </div>
        <div className="cols" style={{
        ['--n' as string]: 4
      }} data-id="element-482" data-mp="2va98hnx5qsm1">
          {WHO_FOR.map(w => <div className="col" key={w.t} data-id="element-483" data-mp="3032d8bsmm0y4">
              <div className="t" data-id="element-484" data-mp="351domqykkjig">{w.t}</div>
              <div className="b" data-id="element-485" data-mp="350c5dz7egqpn">{w.b}</div>
              <div className="tag" data-id="element-486" data-mp="3a0qdfh9040no">{w.tag}</div>
            </div>)}
        </div>
      </Section>

      <Section n="07" label="Proof" className="trust" data-id="element-487" data-mp="3e225dtfckxz1">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-488" data-mp="3e2v6adrmkt99">
          <div className="eyebrow" data-id="element-489" data-mp="12g19qeh37lhv">WORKS WITH</div>
          <div data-id="element-490" data-mp="12cnbnifghyg8">
            {BRAND_ROWS.map((row, r) => <div className={`brands${r === 0 ? ' first' : ''}`} key={r} data-id="element-491" data-mp="ybtkmg6pw3j4" data-mpi={r}>
                {row.map(b => b.file ? <div className="brand" key={b.name} data-id="element-492" data-mp="of71pwxybmjq">
                      <img src={asset(b.file)} alt={b.hideName ? b.name : ''} style={b.tall ? {
                height: 34
              } : undefined} data-id="element-493" data-mp="ogrw9mk9n5hl" />
                      {!b.hideName && <span data-id="element-494" data-mp="1h3w4s1iki1y4">{b.name}</span>}
                    </div> : <div className="brand wm" key={b.name} data-id="element-495" data-mp="1h68n4fs8mebp">
                      {b.name}
                    </div>)}
              </div>)}
          </div>
        </div>
        <div className="cols" data-id="element-496" data-mp="24t6yiz1i2w2r">
          {TRUST.map(t => <div className="col" key={t.k} data-id="element-497" data-mp="24urtuqvn2j1o">
              <div className="eyebrow" style={{
            fontSize: 12
          }} data-id="element-498" data-mp="2028gnv0v5pxe">
                {t.k}
              </div>
              <div className="t" data-id="element-499" data-mp="3uac9gj2xxl0p">
                {t.t.split('\n').map((line, i) => <React.Fragment key={i} data-id="element-500" data-mp="27bde33qcy3z" data-mpi={i}>
                    {i > 0 && <br data-id="element-501" data-mp="2608u12gnmbt" />}
                    {line}
                  </React.Fragment>)}
              </div>
              <div className="b" data-id="element-502" data-mp="3pjvw0yz4dzec">{t.b}</div>
            </div>)}
        </div>
      </Section>

      <StartHere n="08" data-id="element-503" data-mp="3amlcr3g8jp82" />
    </>;
}